// extracted by mini-css-extract-plugin
module.exports = {"text":"EditFunctions_text__14m-i"};